import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a7e9f9fbedae7001408648c_1786810553607_ff1b69b9/knowledgecapital/src/app/not-found.tsx");
